import { useAPIClient } from '../hooks';
import useBaseQuery from './useBaseQuery';
import type { BuildQueryDescriptorParams } from './utils';

export function useQuery<TQueryFnData = unknown, TData = TQueryFnData>(
  url: string,
  params?: BuildQueryDescriptorParams<TQueryFnData, Error, TData>,
) {
  const apiClient = useAPIClient();
  return useBaseQuery<TQueryFnData, TData>(url, apiClient, params);
}

export default useQuery;
